export const statusDraft = "draft";
export const statusNew = "new";
export const statusClosed = "closed";
export const statusrejected = "rejected";
export const statusDelivered = "delivered";
export const statusCompleted = "completed";

export const statuses = [statusDraft, statusNew, statusClosed, statusrejected, statusDelivered, statusCompleted];